import axios from 'axios'
import { SearchUrlParamBuilder } from '@/core/utils'

const URL_PATH = 'api/atas/fiscais'

class FiscaisApiClient {
	async buscarFiscaisListagemModal(objParam) {
		const { filtro, paginacao } = objParam
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}`,
			filters: filtro,
			pagingAndSorting: paginacao,
		}).buildFiltroPadraoEAvancado()

		return await axios.get(`${url}`)
	}
	async adicionarFiscais(objParam) {
		return await axios.post(`${URL_PATH}/adicionar`, objParam)
	}
	async buscarFiscaisAta(objParam) {
		const { filtro, paginacao } = objParam
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/atas`,
			filters: filtro,
			pagingAndSorting: paginacao,
		}).buildFiltroPadraoEAvancado()

		return await axios.get(`${url}`)
	}
	async excluirFiscalAta(idFiscal) {
		return await axios.delete(`${URL_PATH}/excluir/${idFiscal}`)
	}
}

export default new FiscaisApiClient()
